import React, { useState } from "react";
import { loginVendor } from "../../services/api";
import { useNavigate, Link } from "react-router-dom";
import "../../vendor-panel.css";
import logo from "../../assets/vangle.jpeg";

const VendorLogin = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await loginVendor(form);
      localStorage.setItem("vendorToken", res.data.token);
      navigate("/vendor/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vp-auth-wrapper">
      <div className="vp-auth-container">
        <div className="vp-auth-brand">
          <img src={logo} alt="V Angel Coin" />
          <h1>V Angel Coin</h1>
          <p>Vendor Partner Portal</p>
        </div>

        <div className="vp-auth-card">
          <h2>Welcome back</h2>
          <p className="sub">Sign in to your vendor account</p>

          {error && <div className="vp-alert vp-alert-error">{error}</div>}

          <form onSubmit={handleSubmit} className="vp-form">
            <div className="vp-form-group">
              <label>Email Address</label>
              <input className="vp-input" type="email" name="email" placeholder="you@business.com" value={form.email} onChange={handleChange} required />
            </div>
            <div className="vp-form-group">
              <label>Password</label>
              <input className="vp-input" type="password" name="password" placeholder="Enter your password" value={form.password} onChange={handleChange} required />
            </div>
            <button type="submit" className="vp-btn vp-btn-primary vp-btn-lg vp-btn-full" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="vp-auth-links">
            <Link to="/vendor/forgot-password">Forgot Password?</Link>
            <Link to="/vendor/register">Create New Account →</Link>
          </div>
        </div>

        <div className="vp-auth-footer">
          New vendor? <Link to="/vendor/register">Apply to become a partner</Link>
        </div>
      </div>
    </div>
  );
};

export default VendorLogin;
